/* eslint-disable import/no-anonymous-default-export */
var APP_URL = "";

if (process.env.REACT_APP_env === "qa") APP_URL = "https://hyraf-qa.hyly.app/"
if (process.env.REACT_APP_env === "production") APP_URL = "https://hyraf.hyly.app/"
if (process.env.REACT_APP_env === "stg") APP_URL = "https://hyraf-stg.hyly.app/"


export default (message, image, orgColors, facebookShareUrl) => `
<style>
@import url("https://fonts.googleapis.com/css?family=Raleway");
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

input:focus {outline:0;} 
textarea:focus {outline:0;} 
button:focus {outline:0;} 
select:focus {outline:0;} 
a{
  color: ${orgColors ? orgColors.linkColor : '#27bbed'} !important;
}
.hyraf-fb-share-form{
  max-width:500px;
  width:100%;
  margin: auto;
  background: white;
  margin-top:140px;
}
.hyraf-fb-share-form-header{
  height: 80px;
  background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding:0 20px;
}
.hyraf-fb-share-form-header span{
  font-size: 24px;
  color: white;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  display:flex;
  align-items:center;
}
.hyraf-fb-share-form-header .close-btn{
  background:transparent;
  border:none;
  font-size: 30px;
  color:white;
  font-weight: 100;
}

.hyraf-fb-share-form .content{
  padding:20px 20px 30px 20px;
  border: 1px solid #DADADA;
  border-top:none;
}

.hyraf-fb-share-form .content .content-heading{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.hyraf-fb-share-form .content .content-subheading{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin-top:30px;
}

.hyraf-fb-share-form .content .content-label{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(51, 51, 51, 0.75);
  margin-top:30px;
}

.hyraf-fb-share-form .content .content-small-label{
  margin-top:30px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

.hyraf-fb-share-form .content input{
  border: none;
  border-bottom: 1px solid #dadada;
  width: 100%;
  margin-top: 20px;
}

.hyraf-fb-share-form .content textarea{
  border: 1px solid #dadada;
  width: 100%;
  margin-top: 10px;
  height:150px;
}

.hyraf-fb-share-form .content .submit-btn{
  width: 240px;
  height: 48px;
 background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor:pointer;
}
.hyraf-fb-share-form .footer{
  text-align: right;
  margin-top: 20px;
}
.hyraf-copy-link{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #999999;
  justify-content:space-between;
  border:1px solid #eeeeee;
  height:35px;
  margin-top:10px;
  padding-left:10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.hyraf-copy-link button{
  height: 35px;
  border: none;
  background: transparent;
  width: 80px;
  border-left: 1px solid #eeeeee;
  color: #333333;
  cursor:pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  font-family: "Open Sans", sans-serif;
}

.share-buttons-queue{
  display:flex;
  justify-content:space-between;
  margin-top:10px;
}

.share-buttons-queue button{
  width: 100px;
  height: 86px;
  background: #F9F9F9;
  border-radius: 10px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor:pointer;
}
.share-buttons-queue button span{
  margin-top:10px;
  color:#333333;
}
.copied-btn{
  background: #66D184 !important;
  box-shadow: inset 1px 0px 0px #DADADA;
  color:white !important;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.copied-btn svg{
  display:block !important;
}
.copy-btn svg{
  display:none;
} 
.share-form-field .guide{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #999999;
}
.share-form-field label {
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.mt-20{
  margin-top:20px;
}
@media only screen and (max-width: 480px) {
  .hyraf-fb-share-form-header{
    height: 60px;
  }
  .hyraf-fb-share-form-header span{
    font-size: 18px;
  }
  .hyraf-fb-share-form-header .close-btn{
    right: 10px;
    font-size:25px;
  }
  .hyraf-fb-share-form .content .content-heading{
    font-size: 16px;
    line-height: 20px;
  }

  .share-buttons-queue{
    display: grid;
    justify-content: space-between;
    margin-top: 10px;
    gap: 10px;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
  .share-buttons-queue button{
    width:auto;
    height: 44px;
    background: #F9F9F9;
    border-radius: 10px;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .share-buttons-queue button span{
    margin-top:0;
    margin-left:5px;
  }
  .hyraf-copy-link{
    font-size: 12px;
  }
  .hyraf-fb-share-form .footer{
    text-align: center;
  }
}

.fb-post{
  border: 1px solid #DADADA;
  border-radius: 10px;
  margin:auto;
  padding:20px;
}

.fb-post .item{
  display:flex;
  align-items:center;
}
.fb-post .item p{
  background: #e4e6ea;
  width: 38px;
  height: 38px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  border-radius: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fb-post .item span{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: #000000;
}

.fb-post .message{
  margin-top:20px;
  position:relative;
}

.fb-post .message span{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #000000;
}
  .fb-post .message a{
    word-break: break-all;
  }
.fb-post .message img{
  position:absolute;
  right:0;
}

.fb-post .post-image{
  width: 100%;
  margin-top:20px;
}


</style>

<div class="hyraf-fb-share-form">
  <div class="hyraf-fb-share-form-header">
    <button class="close-btn" type="button" onclick="closeSocialPreview('fb-popup')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.5 12.5H2.5" stroke="white" stroke-miterlimit="10"/>
        <path d="M9.5 19.5L2.5 12.5L9.5 5.5" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
      </svg>
    </button>
    <span class="title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 12.073C24 5.446 18.627 0.072998 12 0.072998C5.373 0.072998 0 5.446 0 12.073C0 18.063 4.388 23.027 10.125 23.927V15.542H7.078V12.072H10.125V9.43C10.125 6.423 11.917 4.761 14.658 4.761C15.97 4.761 17.344 4.996 17.344 4.996V7.949H15.83C14.339 7.949 13.874 8.874 13.874 9.823V12.073H17.202L16.67 15.543H13.874V23.928C19.612 23.027 24 18.062 24 12.073Z" fill="#FFFFFF"/>
      </svg>
      &nbsp;
      Facebook
    </span>
    <button class="close-btn" type="button" onclick="closeSocialPreview('fb-popup', 'true')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 5L5 19" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
        <path d="M19 19L5 5" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
      </svg>
    </button>
  </div>
  <div class="content">

    <div class="fb-post">
      <div class="item">
        <p>R</p>
        &nbsp;
        <span class="custom-select">
          Resident<br/>
          <img width="80" alt="fb" src="data:image/png;base64,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">
        </span>
      </div>

      <div class="message">
        <span id="fb-message-content">
          ${message}<br/><br/>
        </span>
        <img alt="smile" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAUCAIAAABnBnglAAAAA3NCSVQICAjb4U/gAAAAEHRFWHRTb2Z0d2FyZQBTaHV0dGVyY4LQCQAAAu9JREFUSMe9ld1S00AUx/cjIQGS9Cv9hJbaGVSmI8LAC/giPoE3voI33nmjb+BreAvjnR9Y2gJCLZR+tzRJm6Sb3fWioKUtDtYZz1V2c3Z/e87Z/R/IOQd/aZxzSinjnHMOAUA39oclwt8yhoQYPaNarRuGORx6GENFUSJRPRQMyrIEIZy5Ct4/Gs55u9MtnZUBAJFIWNMUSVrwKLWsfrPRdhwnHNZTqRWM8fwYzkG91sgXj9ZSyWQyIYri+F/GWKd99enzQSSqZ7OPhSkSumcopmkeHZ8k4rF0OjnBAAAghEJ6YGdn0x7YF+eX00dH90zX6emPeCKayazdVWoIYSDgzzxI12p1Qsg8GNO0rL4Vj8VEUaSUepROODDGiOcBAPRwEGPc7nTnwbTbXVVVJVkCAHw7zH/5ejDhcFG53Nv76LguQigRj1Uv67MvNGeOa3xgwyoUw5LvGUK+caf+YLAoy6PCRiMRxtjELj6flk6nREEAAGg+9eR7aTbGunjl1V6Pvj39hZp5e6s2jEN8/SBi0ch0uD5N82nadX4wYpzOSJpr7f9iAAC81jvX2h93WpBF4pJREJzznmGM3yXOeb8/cF13NHRsR5alGRhq5ydmqV2cOKxl9QnxRtU+v6gUiied7pVt26ZplUrn+aNj5wbTaLVCodCMpInLO+7tWXF5e3wYDPhPjk8N05SkBYRwanX1rFTO5Qpk6CEMVUVZWYkpywoAwHXdVqO9+TQ7WwUGzffu2fNrRvKNEn854Vep1Mrl842Nh36/DwBAKaWM3UgnxhhBCG3HyR8eiaKYzT6aeF6/xYaSGiM1JOpYXJ0uMmWsUDiuXla3tp6EQsFpiSSE5HJFwzB2d7eXlhbnl05CvFKp3Gy24vGYrgdlWRIEgTHmusNez6w3GpTS9fWMpqr/pNCjXDWarUqlyhnHAkYQcc4po4yyQMCfTCYkaXYvgHO0Nc/zej3Ddhwy9LCAZElSNVWW7mw2c2LmMAT+i/0EEGKPBLxEqbQAAAAASUVORK5CYII=" />
      </div>

    <!-- <img id="fb-image" class="post-image" alt="property" src="${image}"/>-->

    </div>
   
    <div class="footer">
      <button class="submit-btn" type="button" onclick="postOnFb()">Post To Facebook</button>
    </div>

    <input type="hidden" id="fb-share-url" value="${facebookShareUrl}"/>
  </div>
</div>
<script>
function postOnFb(){
  let message = document.getElementById("fb-message-content").innerHTML.replace(/(<([^>]+)>)/ig, "");
  // let facebookShareUrl = document.getElementById("fb-share-url").value;


  let enrollData = JSON.parse(localStorage.getItem("enrollData"))
  console.log("https://www.facebook.com/sharer.php?quote=" + "&u=" + enrollData.inviteFacebookUrl)
  window.open("https://www.facebook.com/sharer.php?quote=" + "&u=" + enrollData.inviteFacebookUrl)

  closeSocialPreview('fb-popup')
  openSocialPreview("thanks-popup")
}

</script>
`